import axios from 'util/axiosConfig';

export const fetchAllGroupsAPI = async (payload) => {
    let data = {
        ...payload,
        pageNo: payload.pageNo - 1,
        pageSize: payload.pageSize
    }
    return await axios.post(`/api/v1/groups`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

// export const fetchAllUnassignedGroupsAPI = async (userId) => {
//     return await axios.get(`/api/v1/unassigned-groups`, {
//         params: {
//             userId
//         }
//     })
//         .then(function (response) {
//             if (response.data) {
//                 return { success: true, groups: response.data };
//             } else {
//                 return { success: false };
//             }
//         })
//         .catch(function (error) {
//             return { success: false, error };
//         });
// }


export const fetchGroupMembersAPI = (groupId) => {

    return axios.get('/api/v1/admin/groups-members', {
        params: {
            groupId
        }
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        }
        else {
            return { success: false };
        }
    }).catch(function (error) {
        return { success: false, error }
    })
}

export const addUpdateGroupAPI = (group) => {
    return axios.post(`/api/v1/admin/add-update-group`, group).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        }
        else {
            return { success: false };
        }
    }).catch(function (error) {
        return { success: false, error }
    })
}

export const fetchUnassignedGroupMembersAPI = (groupId) => {

    return axios.get(`/api/v1/admin/unassgined-group-members`, {
        params: {
            groupId
        }
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        }
        else {
            return { success: false };
        }
    }).catch(function (error) {
        return { success: false, error }
    })
}

export const addGroupMemberAPI = (data) => {

    return axios.get(`/api/v1/admin/add-group-member`, {
        params: {
            ...data
        }
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        }
        else {
            return { success: false };
        }
    }).catch(function (error) {
        return { success: false, error }
    })
}

export const removeGroupMemberAPI = (data) => {

    return axios.delete(`/api/v1/admin/remove-group-member`, {
        params: {
            ...data
        }
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        }
        else {
            return { success: false };
        }
    }).catch(function (error) {
        return { success: false, error }
    })
}